(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-text-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    // Countdown ticker. Each element carries its end time (store-timezone epoch) in data-itc-countdown.
    function initCountdown(el) {
      if (el.dataset.itcCdInit) return;
      el.dataset.itcCdInit = '1';

      var end = parseInt(el.getAttribute('data-itc-countdown'), 10) * 1000;
      if (!end) return;

      var dEl = el.querySelector('[data-days]');
      var hEl = el.querySelector('[data-hours]');
      var mEl = el.querySelector('[data-mins]');
      var sEl = el.querySelector('[data-secs]');
      var iv;

      function tick() {
        var diff = end - Date.now();
        if (diff <= 0) {
          if (iv) clearInterval(iv);
          el.style.display = 'none';
          return;
        }
        var s = Math.floor(diff / 1000);
        var d = Math.floor(s / 86400); s -= d * 86400;
        var h = Math.floor(s / 3600); s -= h * 3600;
        var m = Math.floor(s / 60); var sec = s - m * 60;
        if (dEl) dEl.textContent = d;
        if (hEl) hEl.textContent = pad(h);
        if (mEl) mEl.textContent = pad(m);
        if (sEl) sEl.textContent = pad(sec);
      }

      tick();
      iv = setInterval(tick, 1000);
    }

    // Lazy products: clone the inert <template> in when the holder nears the viewport.
    function revealLazy(holder) {
      var tpl = holder.querySelector('template');
      if (!tpl) return;
      holder.appendChild(tpl.content.cloneNode(true));
      tpl.remove();
      holder.removeAttribute('data-itc-lazy');
    }

    function initLazy(holder) {
      if (holder.dataset.itcLazyInit) return;
      holder.dataset.itcLazyInit = '1';

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              revealLazy(entries[i].target);
              io.unobserve(entries[i].target);
            }
          }
        }, { rootMargin: '600px 0px' });
        io.observe(holder);
      } else {
        revealLazy(holder);
      }
    }

    // Wire up every instance on the page (this script is bundled once, not per section).
    function init(scope) {
      var root = scope || document;
      var timers = root.querySelectorAll('[data-itc-countdown]');
      for (var i = 0; i < timers.length; i++) initCountdown(timers[i]);
      var holders = root.querySelectorAll('[data-itc-lazy]');
      for (var j = 0; j < holders.length; j++) initLazy(holders[j]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }

    // Re-init a section re-rendered in the theme editor.
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
